import { InjectionToken } from '@angular/core';
import { ITreatmentSymptomsService } from './treatment-symptoms.interface';

export const TREATMENT_SYMPTOMS_SERVICE = new InjectionToken<ITreatmentSymptomsService>(
  'TREATMENT_SYMPTOMS_SERVICE'
);
